import React, { useEffect, useState } from 'react';
import ButtonCustomIcon from '../../../utils/custom-button-icon';
import ButtonCustomIcon2 from '../../../utils/custom-button-icon2';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getPostalCodes } from '../../../services/postal_code_service';
import { PressData } from '../../../models/listpress';
import { ToastContainer, toast } from 'react-toastify';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}
interface ManagerStateInterface {
    personne: string;
    personne1: string;
    civilite: string;
    civilite1: string;
    civilite2: string;
    civilite3: string;
    nom: string;
    nom1: string;
    nom2: string;
    nom3: string;
    nom5: string;
    prenom: string;
    prenom1: string;
    prenom2: string;
    prenom3: string;
    prenom5: string;
    rcs: string;
    adresse: string;
    adresse1: string;
    adresse2: string;
    adresse5: string;
    adressesuite: string;
    adressesuite1: string;
    adressesuite2: string;
    adressesuite5: string;
    codepostal: string;
    codepostal1: string;
    codepostal2: string;
    ville: string;
    ville1: string;
    ville2: string;
    greffe: string;
}

const AutreRedactionLibre: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {
    const [errors, setErrors] = useState<{ denomination?: string; texteAnnonce?: string }>({});
    const [isTextareaVisible, setIsTextareaVisible] = useState(false);
    const [date, setDate] = useState<string>('');
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [typeChoice, setTypeChoice] = useState('');
    const [postalCode, setPostalCode] = useState<number | null>(null);
    const [postalCode1, setPostalCode1] = useState<number | null>(null);
    const [postalCode2, setPostalCode2] = useState<number | null>(null);
    const [postalCode3, setPostalCode3] = useState<number | null>(null);
    const [postalCode4, setPostalCode4] = useState<number | null>(null);
    const [postalCode5, setPostalCode5] = useState<number | null>(null);
    const [postalCode6, setPostalCode6] = useState<number | null>(null);
    const [postalCode7, setPostalCode7] = useState<number | null>(null);
    const [postalCode8, setPostalCode8] = useState<number | null>(null);
    const [postalCode9, setPostalCode9] = useState<number | null>(null);
    const [commune, setSelectedCommune] = useState<string>("");
    const [filteredPressData, setFilteredPressData] = useState<PressData[]>([]);
    const [communes, setCommunes] = useState<string[]>([]);
    const [communes1, setCommunes1] = useState<string[]>([]);
    const [communes2, setCommunes2] = useState<string[]>([]);
    const [communes3, setCommunes3] = useState<string[]>([]);
    const [communes4, setCommunes4] = useState<string[]>([]);
    const [communes5, setCommunes5] = useState<string[]>([]);
    const [communes6, setCommunes6] = useState<string[]>([]);
    const [communes7, setCommunes7] = useState<string[]>([]);
    const [communes8, setCommunes8] = useState<string[]>([]);
    const [communes9, setCommunes9] = useState<string[]>([]);
    const [pressData, setPressData] = useState<PressData[]>([]);
    const [oppositons, setOppositions] = useState('option01');
    const [showExplanation, setShowExplanation] = useState(false);
    const [donnee, setDonnee] = useState('option01');
    const [service, setService] = useState<string>('option01');
    const options = Array.isArray(societyType) ? societyType : [societyType];
    const handleSelectChangeSociete = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setTypeChoice(event.target.value);
    };

    const [isFocuseed, setIsFocuseed] = useState(false);
    const [isFocuseed1, setIsFocuseed1] = useState(false);
    const [isFocuseed2, setIsFocuseed2] = useState(false);
    const [isFocuseed3, setIsFocuseed3] = useState(false);
    const [isFocuseed4, setIsFocuseed4] = useState(false);
    const [isFocuseed5, setIsFocuseed5] = useState(false);
    const [isFocuseed6, setIsFocuseed6] = useState(false);
    const [isFocuseed7, setIsFocuseed7] = useState(false);
    const [isFocuseed8, setIsFocuseed8] = useState(false);
    const [isFocuseed9, setIsFocuseed9] = useState(false);



    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode) {
                try {
                    const communeName = await getPostalCodes(postalCode);
                    setCommunes([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes([]);
                }
            } else {
                setCommunes([]);
            }
        };

        fetchCommunes();
    }, [postalCode]);
    useEffect(() => {
        if (postalCode && pressData.length > 0) {
            const departmentCode = postalCode.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode, pressData]);
    const handleInputChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode);
    };



    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode1) {
                try {
                    const communeName = await getPostalCodes(postalCode1);
                    setCommunes1([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes1([]);
                }
            } else {
                setCommunes1([]);
            }
        };

        fetchCommunes();
    }, [postalCode1]);
    useEffect(() => {
        if (postalCode1 && pressData.length > 0) {
            const departmentCode = postalCode1.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode1, pressData]);
    const handleInputChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode1(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode);
    };


    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode2) {
                try {
                    const communeName = await getPostalCodes(postalCode2);
                    setCommunes2([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes2([]);
                }
            } else {
                setCommunes2([]);
            }
        };

        fetchCommunes();
    }, [postalCode2]);
    useEffect(() => {
        if (postalCode2 && pressData.length > 0) {
            const departmentCode = postalCode2.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode2, pressData]);
    const handleInputChange4 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode2(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode2);
    };



    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode3) {
                try {
                    const communeName = await getPostalCodes(postalCode3);
                    setCommunes3([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes3([]);
                }
            } else {
                setCommunes3([]);
            }
        };

        fetchCommunes();
    }, [postalCode3]);
    useEffect(() => {
        if (postalCode3 && pressData.length > 0) {
            const departmentCode = postalCode3.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode3, pressData]);
    const handleInputChange6 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode3(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode3);
    };



    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode4) {
                try {
                    const communeName = await getPostalCodes(postalCode4);
                    setCommunes4([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes4([]);
                }
            } else {
                setCommunes4([]);
            }
        };

        fetchCommunes();
    }, [postalCode4]);
    useEffect(() => {
        if (postalCode4 && pressData.length > 0) {
            const departmentCode = postalCode4.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode4, pressData]);
    const handleInputChange8 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode4(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode4);
    };



    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode5) {
                try {
                    const communeName = await getPostalCodes(postalCode5);
                    setCommunes5([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes5([]);
                }
            } else {
                setCommunes5([]);
            }
        };

        fetchCommunes();
    }, [postalCode5]);
    useEffect(() => {
        if (postalCode5 && pressData.length > 0) {
            const departmentCode = postalCode5.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode5, pressData]);
    const handleInputChange10 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode5(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode5);
    };




    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode6) {
                try {
                    const communeName = await getPostalCodes(postalCode6);
                    setCommunes6([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes6([]);
                }
            } else {
                setCommunes6([]);
            }
        };

        fetchCommunes();
    }, [postalCode6]);
    useEffect(() => {
        if (postalCode6 && pressData.length > 0) {
            const departmentCode = postalCode6.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode6, pressData]);
    const handleInputChange13 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode6(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode6);
    };




    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode7) {
                try {
                    const communeName = await getPostalCodes(postalCode7);
                    setCommunes7([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes7([]);
                }
            } else {
                setCommunes7([]);
            }
        };

        fetchCommunes();
    }, [postalCode7]);
    useEffect(() => {
        if (postalCode7 && pressData.length > 0) {
            const departmentCode = postalCode7.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode7, pressData]);
    const handleInputChange14 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode7(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode7);
    };






    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode8) {
                try {
                    const communeName = await getPostalCodes(postalCode8);
                    setCommunes8([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes8([]);
                }
            } else {
                setCommunes8([]);
            }
        };

        fetchCommunes();
    }, [postalCode8]);
    useEffect(() => {
        if (postalCode8 && pressData.length > 0) {
            const departmentCode = postalCode8.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode8, pressData]);
    const handleInputChange15 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode8(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode8);
    };




    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode9) {
                try {
                    const communeName = await getPostalCodes(postalCode9);
                    setCommunes9([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes9([]);
                }
            } else {
                setCommunes9([]);
            }
        };

        fetchCommunes();
    }, [postalCode9]);
    useEffect(() => {
        if (postalCode9 && pressData.length > 0) {
            const departmentCode = postalCode9.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode9, pressData]);
    const handleInputChange16 = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode9(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode9);
    };


    const handledonne = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setDonnee(event.target.value);
    };

    const Renouvellements = [
        { value: 'option01', label: 'Pas de renouvellement' },
        { value: 'option02', label: 'Par tactile reconduction' },
    ];


    const handleInputChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCommune(event.target.value);
    };
    const Donnees = [
        { value: 'option01', label: 'Non' },
        { value: 'option02', label: 'Oui' },
    ];
    const [checked, setChecked] = useState(false);

    const handleCheckboxChange = () => {
        setChecked(!checked);
    };

    const oppositions = [
        { value: 'option01', label: "À l'adresse du bien cédé" },
        { value: 'option02', label: "Autre adresse hors ressort" },
        { value: 'option03', label: "Autre adresse dans le ressort" },
    ];

    const handleAddGerant = () => {
        setGerants([
            ...gerants,
            {
                personne: 'option01',
                personne1: 'option01',
                civilite: 'option01',
                civilite1: 'option01',
                civilite2: 'option01',
                civilite3: 'option01',
                nom: '',
                nom1: '',
                nom2: '',
                nom3: '',
                nom5: '',
                prenom: '',
                prenom1: '',
                prenom2: '',
                prenom3: '',
                prenom5: '',
                rcs: '',
                adresse: '',
                adresse1: '',
                adresse2: '',
                adresse5: '',
                adressesuite: '',
                adressesuite1: '',
                adressesuite2: '',
                adressesuite5: '',
                codepostal: '',
                codepostal1: '',
                codepostal2: '',
                ville: '',
                ville1: '',
                ville2: '',
                greffe: '',
            },
        ]);
    };


    const handleRemoveLastGerant = () => {
        if (gerants.length > 1) {
            setGerants(gerants.slice(0, -1));
        }
    };
    const handleInputChange = (
        index: number,
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = event.target;
        const newGerants = [...gerants];
        newGerants[index] = { ...newGerants[index], [name]: value };
        setGerants(newGerants);
    };
    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode) {
                try {
                    const communeName = await getPostalCodes(postalCode);
                    setCommunes([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes([]);
                }
            } else {
                setCommunes([]);
            }
        };


        fetchCommunes();
    }, [postalCode]);

    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode1) {
                try {
                    const communeName = await getPostalCodes(postalCode1);
                    setCommunes1([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes1([]);
                }
            } else {
                setCommunes1([]);
            }
        };

        fetchCommunes();
    }, [postalCode1]);

    useEffect(() => {
        if (postalCode && pressData.length > 0) {
            const departmentCode = postalCode.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode, pressData]);
    const NatureActe = [
        { value: 'option01', label: 'acte authentique' },
        { value: 'option02', label: 'acte sous seing privé' },
    ];
    const [Renouvellement, setRenouvellement] = useState<string>('option01');

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const handlePersonne1 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setpersonne1(event.target.value);
    };
    const Personnes = [
        { value: 'opti01', label: 'Personne physique' },
        { value: 'opti02', label: 'Personne morale' }
    ];
    const Civilite = [
        { value: 'op1', label: 'Monsieur' },
        { value: 'op2', label: 'Madame' },
    ];
    const [nature, setNature] = useState('option01');

    // Fonction pour valider le format de la date (JJ/MM/AAAA)
    const validateDate = (value: string) => {
        const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
        return regex.test(value);
    };
    const handlecivilite1 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCivilite1(event.target.value);
    };
    let hasDisplayedError = false;
    const validate = () => {
        const newErrors: {
            denomination1?: string;
            ville?: string;
            activite?: string;
            objetsocial?: string;
            texteAnnonce?: string;
            dateeacte?: string;
            objet?: string;
            capital?: string;
            Duree?: string;
            adresse?: string;
            postalCode?: string;
        } = {};
        const errorFields: string[] = [];
        if (!formData.denomination1) {
            newErrors.denomination1 = "Le champ 'Dénomination' est obligatoire.";
            errorFields.push("Dénomination");
        }
        if (!formData.dateeacte) {
            newErrors.dateeacte = "Le champ 'date' est obligatoire.";
            errorFields.push("Date d'effet");
        }
        if (!formData.adresse2) {
            newErrors.adresse = "Le champ 'adresse' est obligatoire.";
            errorFields.push("adresse");
        }
        if (!formData.activite) {
            newErrors.activite = "Le champ 'activite' est obligatoire.";
            errorFields.push("activite");
        }
        


        
        if (errorFields.length > 0 && !hasDisplayedError) {
            const errorMessage = `Les champs suivants sont obligatoires : ${errorFields.join(", ")}.`;
            toast.error(errorMessage, {
                position: "top-right",
            });
            hasDisplayedError = true;
        }


        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const [civilite1, setCivilite1] = useState<string>('option01');
    const handleFocus = () => {
        setShowExplanation(true);
    };
    const Personnes1 = [
        { value: 'option01', label: 'Personne physique' },
        { value: 'option02', label: 'Personne morale' },
    ];
    const Civilites1 = [
        { value: 'option01', label: 'Monsieur' },
        { value: 'option02', label: 'Madame' },
    ];


    const handleDateChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        setDateFunc: React.Dispatch<React.SetStateAction<string>>,
        handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    ) => {
        let value = e.target.value.replace(/[^\d/]/g, '');

        if (value.length === 2 || value.length === 5) {
            value += '/';
        }

        if (value.length <= 10) {
            setDateFunc(value);
        }

        handleChange(e);
    };
    const handleBlur = (value: string, setDateFunc: React.Dispatch<React.SetStateAction<string>>) => {
        if (!validateDate(value)) {
            setDateFunc('');
        }
    };
    const [personne1, setpersonne1] = useState<string>('option01');
    const switchTab = (tab: string) => {
setActiveTab(tab);
    };
    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>, setState: React.Dispatch<React.SetStateAction<string>>) => {
        setState(event.target.value);
    };

    const [formData, setFormData] = useState({
        denomination1: '',
        denomination2: '',
        sigle: '',
        montant1: '',
        activite: '',
        cas1: '',
        bureau: '',
        personnes: 'Personne physique',
        decision: '',
        personne: 'Personne physique',
        capital1: '',
        greffe1: '',
        Nature: '',
        date: '',
        rcs: '',
        capital: '',
        Duree: '',
        adresse: '',
        adressesuite: '',
        adresseeffet: '',
        formejuridique: '',
        objet: '',
        codePostal: '',
        ville: '',
        greffe: '',
        type: '',
        objetsocial: '',
        denomination1nouvelle: '',
        capitalnouveau: '',
        dateeacte2: '',
        dateeffet: '',
        dateeacte: '',
        civiliteLiquidateur: '',
        nomliquidateur: '',
        prenomLiquidateur: '',
        adresseLiquidateur: '',
        adressesuiteLiquidateur: '',
        codepostalLiquidateur: '',
        villeLiquidateur: '',
        rcsLiquidateur: '',
        denominationliquidateur: '',
        capitalliquidateur: '',
        greffeLiquidateur: '',
        adresseliquidation: 'Au siège social',
        civilitesiegeLiquidateur: '',
        nomsiegeliquidateur: '',
        prenomsiegeLiquidateur: '',
        adressesiegeLiquidateur: '',
        adressesuitesiegeLiquidateur: '',
        codepostalSiegeLiquidateur: '',
        villeSiegeLiquidateur: '',
        saisiradresse: 'Non',
        adresseCorrespondant: '',
        adresseeffetCorrespondant: '',
        codePostalCorrespondant: '',
        villeCorrespondant: '',
        postalCode: '',
        postalCode1:'',
        civilite: '',
        dateeacte1: '',
        nom1: '',
        prenom1: '',
        adresse1: '',
        adressesuite1: '',
        nom2: '',
        prenom2: '',
        adresse2: '',
        adressesuite2: '',
        civilite2: '',
        admission: '',
        clause: '',
        nom: '',
        prenom: '',
        bordereau: '',
        cas: '',
        extrait: '',
        dosier: '',
        reference: '',
        montant: '',
        dateeacte3: '',
        dateeacte4: '',
        dateeacte5: '',
    })
    const handleoppositions = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setOppositions(event.target.value);
    };
    const handleBlur1 = () => {
        setShowExplanation(false);
    };

    const [gerants, setGerants] = useState<ManagerStateInterface[]>([
        {
            personne: 'option01',
            personne1: 'option01',
            civilite: 'option01',
            civilite1: 'option01',
            civilite2: 'option01',
            civilite3: 'option01',
            nom: '',
            nom1: '',
            nom2: '',
            nom3: '',
            nom5: '',
            prenom: '',
            prenom1: '',
            prenom2: '',
            prenom3: '',
            prenom5: '',
            rcs: '',
            adresse: '',
            adresse1: '',
            adresse2: '',
            adresse5: '',
            adressesuite: '',
            adressesuite1: '',
            adressesuite2: '',
            adressesuite5: '',
            codepostal: '',
            codepostal1: '',
            codepostal2: '',
            ville: '',
            ville1: '',
            ville2: '',
            greffe: '',
        },
    ]);
    const Lieus = [
        { value: 'option01', label: 'Geffe identiques au fonds' },
        { value: 'option02', label: 'Autre Greffe' },
    ];
    const renouvellements = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRenouvellement(event.target.value);
    };
    const Services = [
        { value: 'option01', label: 'Service des impôts des entreprises (SIE)' },
        { value: 'option02', label: 'Service départemental des Enregistrements (SDE)' },
    ];
    const [lieu, setLieu] = useState('option01');
    const handlelieu = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setLieu(event.target.value);
    };

    const selectedRenouvellement = Renouvellements.find(option => option.value === Renouvellement);
    const [submittedData, setSubmittedData] = useState<{ [key: string]: string } | null>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            updateTxtAnnonce(`Suivant acte SSP du : ${formData.dateeacte}\n${formData.denomination2 || ""}\n${gerants.map(gerant => `M. ${gerant.nom} ${gerant.prenom} , demeurant à ${gerant.adresse} ${gerant.adressesuite} ${postalCode1 || ""} ${communes1 || ""}\na confié en location-gérance à\nM. ${gerant.nom5} ${gerant.prenom5} , demeurant à ${gerant.adresse5} ${gerant.adressesuite5} ${postalCode2 || ""} ${communes2 || ""}\ncommerce de : ${formData.activite}\nsis et exploité ${formData.adresse2} ${formData.adressesuite2} ${postalCode3 || ""} ${communes3 || ""} du ${formData.dateeacte2} au ${formData.dateeacte3}\nrenouvelable ${selectedRenouvellement ? selectedRenouvellement.label : ""}`)}`)
            setSubmittedData(formData);
            updateDenomination(formData.denomination1)
            setIsTextareaVisible(true);

        }
        console.log(formData);
        const isValid = validate();
        if (isValid) {
            setFormSubmitted(true);
        }
    };
    const Nature = [
        { value: 'option01', label: '' },
        { value: 'option02', label: 'Etablissement principal' },
        { value: 'option03', label: 'Etablissement secondaire' },
        { value: 'option04', label: 'Etablissement complémentaire' },
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };
    const handleNext = () => {
        switchTab(getNextTab(activeTab));
    };
    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
    };


    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'signatureDesStatus';
            case 'signatureDesStatus':
                return 'laSociété';
            case 'laSociété':
                return 'adresseDuSiegeSocial';
            case 'adresseDuSiegeSocial':
                return 'laGérance';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'signatureDesStatus':
                return 'raisonSociale';
            case 'laSociété':
                return 'signatureDesStatus';
            case 'adresseDuSiegeSocial':
                return 'laSociété';
            case 'laGérance':
                return 'adresseDuSiegeSocial';
            default:
                return currentTab;
        }
    };

    return (
        <>
            <div className='container my-3'>
                <ul className="nav nav-underline">
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'raisonSociale' ? 'active' : ''}`}
                            onClick={() => visitedTabs.includes('raisonSociale') && switchTab('raisonSociale')}
                        >
                            Raison Sociale
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'signatureDesStatus' ? 'active' : ''} ${!visitedTabs.includes('signatureDesStatus') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('signatureDesStatus') && switchTab('signatureDesStatus')}
                        >
                            Le bailleur
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'laSociété' ? 'active' : ''} ${!visitedTabs.includes('laSociété') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('laSociété') && switchTab('laSociété')}
                        >
                            Le locataire
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'adresseDuSiegeSocial' ? 'active' : ''} ${!visitedTabs.includes('adresseDuSiegeSocial') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('adresseDuSiegeSocial') && switchTab('adresseDuSiegeSocial')}
                        >
                            L'adresse d'exploitation du fonds de commerce
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'laGérance' ? 'active' : ''} ${!visitedTabs.includes('laGérance') ? 'disabled' : ''}`}
                            onClick={() => visitedTabs.includes('laGérance') && switchTab('laGérance')}
                        >
                            Durée de la location gérance
                        </a>
                    </li>
                </ul>
            </div>
            <ToastContainer />
            <form onSubmit={handleSubmit}>
                {activeTab === 'raisonSociale' && (
                    <div className="tab-content">
                        <p><strong>Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.</strong></p>
                        <div className="mb-3 row">
                            <label htmlFor="denomination1" className="col-sm-2 col-form-label">Dénomination</label>
                            <div className="col-sm-10">
                                <input
                                    className={`form-control ${errors.denomination ? 'is-invalid' : ''}`}
                                    type="text"
                                    id="denomination1"
                                    value={formData.denomination1}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 'signatureDesStatus' && (
                    <div className="tab-content">
                        {gerants.map((gerant, index) => (
                            <div key={index}>
                                {/* Contenu du formulaire du gérant */}
                                <div className="mb-3 row">
                                    <div className="mb-3 row">
                                        <label htmlFor="personne" className="col-sm-2 col-form-label">Personne</label>
                                        <div className="col-sm-10">
                                            <select
                                                className="form-select"
                                                id="personne"
                                                onChange={handleChange}
                                                value={formData.personne}
                                            >
                                                {Personnes.map((option) => (
                                                    <option key={option.value} value={option.label}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {formData.personne === 'Personne physique' && (
                                    <div className="mb-3 row">
                                        <div className="mb-3 row">
                                            <label htmlFor="civilite" className="col-sm-2 col-form-label">Civilité</label>
                                            <div className="col-sm-10">
                                                <select
                                                    className="form-select"
                                                    name="civilite"
                                                    value={gerant.civilite}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                >
                                                    {Civilite.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>
                                        <div className="mb-3 row">
                                            <label htmlFor="nom" className="col-sm-2 col-form-label">Nom</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="nom"
                                                    value={gerant.nom}
                                                    onChange={(e) => handleInputChange(index, e)}

                                                />
                                            </div>
                                            <label htmlFor="prenom" className="col-sm-2 col-form-label">Prénom</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="prenom"
                                                    value={gerant.prenom}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">Adresse</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name="adresse"
                                                    value={gerant.adresse}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="adressesuite"
                                                    value={gerant.adressesuite}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label htmlFor="postalCode1" className="col-sm-2 col-form-label">Code postal</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="postalCode1"
                                                    value={postalCode1 !== null ? postalCode1.toString() : ''}
                                                    onChange={handleInputChange3}
                                                    onFocus={() => setIsFocuseed9(true)}
                                                    onBlur={() => setIsFocuseed9(false)}
                                                />
                                            </div>
                                            <label htmlFor="ville" className="col-sm-2 col-form-label">Ville</label>
                                            <div className="col-sm-4">
                                                <select className="form-select" id="ville" name="ville" onChange={handleInputChange2}>
                                                    {communes1.map((commune, index) => (
                                                        <option key={index} value={commune}>
                                                            {commune}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {isFocuseed9 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Pour une adresse hors France ou Dom-Tom écrire : 00000
                                                </p>
                                            </span>
                                        )}
                                        {/* Ajout d'une ligne horizontale après chaque gérant sauf le dernier */}
                                        {index < gerants.length - 1 && <hr />}

                                    </div>
                                )}
                                {formData.personne === 'Personne morale' && (

                                    <div className="mb-3 row">

                                        <div className="mb-3 row">
                                            <label htmlFor="denomination1" className="col-sm-2 col-form-label">Dénomination</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.denomination ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    id="denomination1"
                                                    value={formData.denomination1}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed6(true)}
                                                    onBlur={() => setIsFocuseed6(false)}
                                                />
                                            </div>

                                            <label htmlFor="sociteChoice" className="col-sm-2 col-form-label">Forme juridique</label>
                                            <div className='col-sm-4'>
                                                <select
                                                    className="form-select"
                                                    id="sociteChoice"
                                                    name="sociteChoice"
                                                    onChange={handleSelectChangeSociete}
                                                    value={typeChoice}
                                                >
                                                    {options.map((option, index) => (
                                                        <option key={index} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {isFocuseed6 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Nom de la société, comme mentionné dans les statuts.
                                                </p>
                                            </span>
                                        )}

                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">Adresse</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name="adresse"
                                                    value={gerant.adresse}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="adressesuite"
                                                    value={gerant.adressesuite}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                        </div>
                                        <div className="mb-3 row">
                                            <label htmlFor="postalCode1" className="col-sm-2 col-form-label">Code postal</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="postalCode1"
                                                    value={postalCode1 !== null ? postalCode1.toString() : ''}
                                                    onChange={handleInputChange3}
                                                    onFocus={() => setIsFocuseed9(true)}
                                                    onBlur={() => setIsFocuseed9(false)}
                                                />
                                            </div>
                                            <label htmlFor="ville" className="col-sm-2 col-form-label">Ville</label>
                                            <div className="col-sm-4">
                                                <select className="form-select" id="ville" name="ville" onChange={handleInputChange2}>
                                                    {communes1.map((commune, index) => (
                                                        <option key={index} value={commune}>
                                                            {commune}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {isFocuseed9 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Pour une adresse hors France ou Dom-Tom écrire : 00000
                                                </p>
                                            </span>
                                        )}
                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">Rcs</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    id="rcs"
                                                    value={formData.rcs}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed7(true)}
                                                    onBlur={() => setIsFocuseed7(false)}
                                                />
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Greffe</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="greffe1"
                                                    value={formData.greffe1}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                        </div>
                                        {isFocuseed7 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Numéro RCS de la société, exemple : 955 467 946
                                                    Soyez vigilant <br />
                                                    la récupération automatique des données de société dépend de l’INSEE et peut ne pas être à jour.
                                                </p>
                                            </span>
                                        )}
                                        <div className="mb-3 row">
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Capital</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="capital1"
                                                    value={formData.capital1}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed8(true)}
                                                    onBlur={() => setIsFocuseed8(false)}
                                                />
                                            </div>
                                        </div>
                                        {isFocuseed8 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Montant du capital tel que mentionné dans les statuts. Par exemple : 1535,65
                                                </p>
                                            </span>
                                        )}
                                        {/* Ajout d'une ligne horizontale après chaque gérant sauf le dernier */}
                                        {index < gerants.length - 1 && <hr />}

                                    </div>

                                )}
                            </div>
                        ))}



                        <p><strong>Date de l'AG</strong></p>
                        <div className="mb-3 row">
                            <label htmlFor="date" className="col-sm-2 col-form-label">Date de l'acte</label>
                            <div className="col-sm-10">
                                <input
                                    className="form-control"
                                    type="date"
                                    id="dateeacte"
                                    value={formData.dateeacte}
                                    onChange={(e) => handleDateChange(e, setDate, handleChange)}
                                    // onBlur={() => handleBlur(date, setDate)}
                                    placeholder="JJ/MM/AAAA"
                                    onFocus={() => setIsFocuseed(true)}
                                    onBlur={() => setIsFocuseed(false)}
                                />
                            </div>
                        </div>
                        {isFocuseed && (
                            <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px' }}>
                                <p style={{
                                    backgroundColor: '#3EA3B2',
                                    color: 'white',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    margin: 0,
                                    width: '25%',
                                    boxSizing: 'border-box'
                                }}>
                                    EXPLICATION<br />
                                    Cette date qui matérialise la date de création de la société,doit être identique à celle qui figure à la page de signature des statuts de la société au format : jj/mm/aaaa
                                </p>
                            </span>
                        )}

                    </div>
                )}
                {activeTab === 'laSociété' && (
                    <div className="tab-content">
                        {gerants.map((gerant, index) => (
                            <div key={index}>
                                {/* Contenu du formulaire du gérant */}
                                <div className="mb-3 row">
                                    <div className="mb-3 row">
                                        <label htmlFor="personne" className="col-sm-2 col-form-label">Personne</label>
                                        <div className="col-sm-10">
                                            <select
                                                className="form-select"
                                                id="personne"
                                                onChange={handleChange}
                                                value={formData.personne}
                                            >
                                                {Personnes.map((option) => (
                                                    <option key={option.value} value={option.label}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {formData.personne === 'Personne physique' && (
                                    <div className="mb-3 row">
                                        <div className="mb-3 row">
                                            <label htmlFor="civilite" className="col-sm-2 col-form-label">Civilité</label>
                                            <div className="col-sm-10">
                                                <select
                                                    className="form-select"
                                                    name="civilite"
                                                    value={gerant.civilite}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                >
                                                    {Civilite.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>
                                        <div className="mb-3 row">
                                            <label htmlFor="nom" className="col-sm-2 col-form-label">Nom</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="nom5"
                                                    value={gerant.nom5}
                                                    onChange={(e) => handleInputChange(index, e)}

                                                />
                                            </div>
                                            <label htmlFor="prenom" className="col-sm-2 col-form-label">Prénom</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="prenom5"
                                                    value={gerant.prenom5}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">Adresse</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name="adresse5"
                                                    value={gerant.adresse5}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="adressesuite5"
                                                    value={gerant.adressesuite5}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label htmlFor="postalCode1" className="col-sm-2 col-form-label">Code postal</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="postalCode2"
                                                    value={postalCode2 !== null ? postalCode2.toString() : ''}
                                                    onChange={handleInputChange4}
                                                    onFocus={() => setIsFocuseed9(true)}
                                                    onBlur={() => setIsFocuseed9(false)}
                                                />
                                            </div>
                                            <label htmlFor="ville" className="col-sm-2 col-form-label">Ville</label>
                                            <div className="col-sm-4">
                                                <select className="form-select" id="ville" name="ville" onChange={handleInputChange2}>
                                                    {communes2.map((commune, index) => (
                                                        <option key={index} value={commune}>
                                                            {commune}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {isFocuseed9 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Pour une adresse hors France ou Dom-Tom écrire : 00000
                                                </p>
                                            </span>
                                        )}
                                        {/* Ajout d'une ligne horizontale après chaque gérant sauf le dernier */}
                                        {index < gerants.length - 1 && <hr />}

                                    </div>
                                )}
                                {formData.personne === 'Personne morale' && (

                                    <div className="mb-3 row">

                                        <div className="mb-3 row">
                                            <label htmlFor="denomination1" className="col-sm-2 col-form-label">Dénomination</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.denomination ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    id="denomination2"
                                                    value={formData.denomination2}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed6(true)}
                                                    onBlur={() => setIsFocuseed6(false)}
                                                />
                                            </div>

                                            <label htmlFor="sociteChoice" className="col-sm-2 col-form-label">Forme juridique</label>
                                            <div className='col-sm-4'>
                                                <select
                                                    className="form-select"
                                                    id="sociteChoice"
                                                    name="sociteChoice"
                                                    onChange={handleSelectChangeSociete}
                                                    value={typeChoice}
                                                >
                                                    {options.map((option, index) => (
                                                        <option key={index} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {isFocuseed6 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Nom de la société, comme mentionné dans les statuts.
                                                </p>
                                            </span>
                                        )}

                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">Adresse</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name="adresse5"
                                                    value={gerant.adresse5}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="adressesuite5"
                                                    value={gerant.adressesuite5}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                        </div>
                                        <div className="mb-3 row">
                                            <label htmlFor="postalCode1" className="col-sm-2 col-form-label">Code postal</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="postalCode2"
                                                    value={postalCode2 !== null ? postalCode2.toString() : ''}
                                                    onChange={handleInputChange4}
                                                    onFocus={() => setIsFocuseed9(true)}
                                                    onBlur={() => setIsFocuseed9(false)}
                                                />
                                            </div>
                                            <label htmlFor="ville" className="col-sm-2 col-form-label">Ville</label>
                                            <div className="col-sm-4">
                                                <select className="form-select" id="ville" name="ville" onChange={handleInputChange2}>
                                                    {communes2.map((commune, index) => (
                                                        <option key={index} value={commune}>
                                                            {commune}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {isFocuseed9 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Pour une adresse hors France ou Dom-Tom écrire : 00000
                                                </p>
                                            </span>
                                        )}
                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">Rcs</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    id="rcs"
                                                    value={formData.rcs}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed7(true)}
                                                    onBlur={() => setIsFocuseed7(false)}
                                                />
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Greffe</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="greffe1"
                                                    value={formData.greffe1}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                        </div>
                                        {isFocuseed7 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Numéro RCS de la société, exemple : 955 467 946
                                                    Soyez vigilant <br />
                                                    la récupération automatique des données de société dépend de l’INSEE et peut ne pas être à jour.
                                                </p>
                                            </span>
                                        )}
                                        <div className="mb-3 row">
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Capital</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="capital1"
                                                    value={formData.capital1}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed8(true)}
                                                    onBlur={() => setIsFocuseed8(false)}
                                                />
                                            </div>
                                        </div>
                                        {isFocuseed8 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Montant du capital tel que mentionné dans les statuts. Par exemple : 1535,65
                                                </p>
                                            </span>
                                        )}
                                        {/* Ajout d'une ligne horizontale après chaque gérant sauf le dernier */}
                                        {index < gerants.length - 1 && <hr />}

                                    </div>

                                )}
                            </div>
                        ))}



                        <p><strong>L'activité du fonds de commerce</strong></p>
                        <div className="mb-3 row">
                            <label htmlFor="Activité" className="col-sm-2 col-form-label">Activité</label>
                            <div className="col-sm-10">
                                <textarea
                                    className="form-control"
                                    id='activite'
                                    rows={2}
                                    value={formData.activite}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                    </div>
                )}
                {activeTab === 'adresseDuSiegeSocial' && (
                    <div className="tab-content">
                        <div className="mb-3 row">
                            <label htmlFor="adresse2" className="col-sm-2 col-form-label">Adresse</label>
                            <div className="col-sm-10">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="adresse2"
                                    value={formData.adresse2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label htmlFor="adressesuite2" className="col-sm-2 col-form-label">Adresse suite</label>
                            <div className="col-sm-10 mb-2">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="adressesuite2"
                                    value={formData.adressesuite2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label htmlFor="codepostal2" className="col-sm-2 col-form-label">Code postal</label>
                            <div className="col-sm-10">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="codepostal3"
                                    value={postalCode3 !== null ? postalCode3.toString() : ''}
                                    onChange={handleInputChange6}
                                    onFocus={() => setIsFocuseed3(true)}
                                    onBlur={() => setIsFocuseed3(false)}
                                />
                            </div>
                        </div>
                        {isFocuseed3 && (
                            <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                <p style={{
                                    backgroundColor: '#3EA3B2',
                                    color: 'white',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    margin: 0,
                                    width: '25%',
                                    boxSizing: 'border-box'
                                }}>
                                    EXPLICATION<br />
                                    Si l'adresse est hors France ou Dom-Tom écrire : 00000
                                </p>
                            </span>
                        )}
                        <div className="mb-3 row">
                            <label htmlFor="ville" className="col-sm-2 col-form-label">Ville</label>
                            <div className="col-sm-10">
                                <select className="form-select" id="ville" name="ville" onChange={handleInputChange2}>
                                    {communes3.map((commune, index) => (
                                        <option key={index} value={commune}>
                                            {commune}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'laGérance' && (
                    <div className="tab-content">
                        {gerants.map((gerant, index) => (
                            <div key={index}>
                                <div className="mb-3 row">
                                    <label htmlFor="civilite" className="col-sm-2 col-form-label">Date de début</label>
                                    <div className="col-sm-10">
                                        <input
                                            className="form-control"
                                            type="date"
                                            id="dateeacte2"
                                            value={formData.dateeacte2}
                                            onChange={(e) => handleDateChange(e, setDate, handleChange)}
                                            // onBlur={() => handleBlur(date, setDate)}
                                            placeholder="JJ/MM/AAAA"
                                            onFocus={() => setIsFocuseed4(true)}
                                            onBlur={() => setIsFocuseed4(false)}
                                        />
                                    </div>
                                </div>
                                {isFocuseed4 && (
                                    <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                        <p style={{
                                            backgroundColor: '#3EA3B2',
                                            color: 'white',
                                            padding: '10px',
                                            borderRadius: '4px',
                                            margin: 0,
                                            width: '25%',
                                            boxSizing: 'border-box'
                                        }}>
                                            EXPLICATION<br />
                                            Date de début de la location gérance : jj/mm/aaaa
                                        </p>
                                    </span>
                                )}

                                <div className="mb-3 row">
                                    <label htmlFor="civilite" className="col-sm-2 col-form-label">Date de fin</label>
                                    <div className="col-sm-10">
                                        <input
                                            className="form-control"
                                            type="date"
                                            id="dateeacte3"
                                            value={formData.dateeacte3}
                                            onChange={(e) => handleDateChange(e, setDate, handleChange)}
                                            // onBlur={() => handleBlur(date, setDate)}
                                            placeholder="JJ/MM/AAAA"
                                            onFocus={() => setIsFocuseed5(true)}
                                            onBlur={() => setIsFocuseed5(false)}
                                        />
                                    </div>
                                </div>
                                {isFocuseed5 && (
                                    <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                        <p style={{
                                            backgroundColor: '#3EA3B2',
                                            color: 'white',
                                            padding: '10px',
                                            borderRadius: '4px',
                                            margin: 0,
                                            width: '25%',
                                            boxSizing: 'border-box'
                                        }}>
                                            EXPLICATION<br />
                                            Date de fin de la location gérance : jj/mm/aaaa
                                        </p>
                                    </span>
                                )}
                                <div className="mb-3 row">
                                    <label htmlFor="Renouvellement" className="col-sm-2 col-form-label">Renouvellement</label>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select"
                                            name="Renouvellement"
                                            value={Renouvellement}
                                            onChange={renouvellements}
                                        >
                                            {Renouvellements.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="main">
                            <button className="btn btn-primary" type="submit">Soumetre</button>
                        </div>
                    </div>

                )}
            </form>
            {submittedData && (
                <div className="mt-4">
                    <h4>Texte de l'annonce:</h4>
                    <textarea
                        className="form-control"
                        rows={5}
                        value={txtAnnonce}
                        onChange={handleChange}
                    />
                </div>
            )}
            {/* Boutons Précédent et Suivant */}
            <div className="d-flex justify-content-center mt-4">
                {activeTab !== 'raisonSociale' && (
                    <ButtonCustomIcon
                        title="Précédent"
                        icon={faArrowLeft}
                        color="#F4A261"
                        onClick={handlePrevious}
                    />
                )}
                {activeTab !== 'laGérance' && (
                    <ButtonCustomIcon2
                        title="Suivant"
                        icon={faArrowRight}
                        color="#F4A261"
                        onClick={handleNext}
                    />
                )}
            </div>
            {formSubmitted && activeTab === 'laGérance' && (
                <button onClick={goToSupportPresse}>Suivant</button>
            )}
        </>
    );
};

export default AutreRedactionLibre;